import type { IVocalise } from './vocalise';
import { vocaliseSchema } from './vocalise';
import { actionCreator, Joi, objectSchemaOf } from '../helpers';

export const PREPARE = 'VOCALISE/PREPARE';

export interface IPrepareAction {
  type: typeof PREPARE;
  payload: IVocalise;
}

export const prepareActionSchema = objectSchemaOf<IPrepareAction>({
  type: Joi.string().required().valid(PREPARE),
  payload: vocaliseSchema.required(),
});

export const prepare = actionCreator({
  type: PREPARE,
  schema: prepareActionSchema,
});
